import { CHARCOAL_GREY } from '~/Constants/Colors.constants';
import { FONT_SIZE_SMALLISH, FONT_SIZE_X_LARGE } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const FilterItemsStyles = makeStyles((theme) => ({
  list: {
    width: '100%',
    padding: 0,
    margin: 0,
  },
  listItem: {
    padding: '0 0 0 48px',
    maxWidth: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '0 0 0 25px',
    },
  },
  titleText: {
    color: CHARCOAL_GREY,
    fontWeight: 'bold',
    fontSize: FONT_SIZE_SMALLISH,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '16px',
    letterSpacing: 0.5,
  },
  listItemCheckboxContainer: {
    minWidth: 'auto',
  },
  listItemIcon: {
    minWidth: 'auto',
    paddingRight: 10,
    [theme.breakpoints.down('md')]: {
      paddingRight: 7,
    },
  },
  checkbox: {
    padding: 8,
    [theme.breakpoints.down('md')]: {
      padding: 10,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 19,
      [theme.breakpoints.down('md')]: {
        fontSize: FONT_SIZE_X_LARGE,
      },
    },
  },
}));
